module.exports = __webpack_public_path__ + "img/aduaneros-header.ee2aaec1.png";